module.exports = __webpack_public_path__ + "static/media/qr_ios.97b72468.png";